const $ = jQuery.noConflict();

'use strict';

const verticalTab = {
	/**
	* @description Cache dom and strings
	* @type {object}
	*/

	/** @description Initialize */
	init: function() {
		this.verticalTabs();
	},
	/** @description */

	verticalTabs() {
		$('.tab').parent().removeClass('js-active-tab');
		$('.tab').parent().first().addClass('js-active-tab');
		$('.tab').on('click', function(evt) {
			evt.preventDefault();
			$(this).toggleClass('active');
			$(this).parent().addClass('js-active-tab');
			$(this).parent().siblings().find('.tab.active').removeClass('active');
			$(this).parent().siblings().removeClass('js-active-tab');
			const sel = this.getAttribute('data-toggle-target');
			$('.tab-content').removeClass('active').filter(sel).addClass('active');
		});
	}
};
export default verticalTab;